import validator from 'validator';

export const validateEmailOption = (label = '') => {
  if (label.indexOf(',') !== -1) {
    return (
      label.split(',').reduce((valid, label) => {
        if (valid === false) {
          return false;
        }
        return validator.isEmail(label.trim());
      }, undefined) || false
    );
  }
  return validator.isEmail(label);
};

export const validateTelephoneOption = (label = '') => {
  if (label.indexOf(',') !== -1) {
    return (
      label.split(',').reduce((valid, label) => {
        if (valid === false) {
          return false;
        }
        return validator.isMobilePhone(
          label.trim().replace(/[^a-zA-Z0-9+]+/, ''),
          'any'
        );
      }, undefined) || false
    );
  }
  return validator.isMobilePhone(label.replace(/[^a-zA-Z0-9+]+/, ''), 'any');
};

export const dedupe = (arrayOfObjects, uniqueKey) => {
  return arrayOfObjects.reduce(
    ({ seen, deduped }, item) => {
      const value = item[uniqueKey];
      if (seen[value]) {
        return { seen, deduped };
      }
      return {
        seen: Object.assign({}, seen, { [value]: true }),
        deduped: deduped.concat(item),
      };
    },
    { seen: {}, deduped: [] }
  ).deduped;
};
